<template>
  <div class="container">
    <HeadingOne class="-margin-md">審査結果のご確認</HeadingOne>

    <NoticeBox class="-success -margin-md">
      <NoticeBody
        >このたびは、au PAY
        スマートローンにお申し込みいただき、誠にありがとうございます。<br />審査の結果、以下の内容でご契約が可能です。</NoticeBody
      >
    </NoticeBox>

    <TableBox class="-entry">
      <TableBody>
        <TableRow>
          <TableHeader> ご利用限度額 </TableHeader>
          <TableData class="-pctextright">
            {{ numberToCurrency(userData.loan_credit_limit) }}
          </TableData>
        </TableRow>
        <TableRow>
          <TableHeader> お借り入れ利率（実質年率） </TableHeader>
          <TableData class="-pctextright">
            {{ numberToPercentage(userData.loan_contractual_interest_rate) }}
          </TableData>
        </TableRow>
      </TableBody>
    </TableBox>

    <p class="_mt-30">
      ご利用にあたりご契約手続きの前に、秘密のことばの設定が必要となります。
    </p>

    <BtngroupSingle class="-margin-lg">
      <BtnMain class="-main" router-name="en015"> 秘密のことば設定へ </BtnMain>
    </BtngroupSingle>
  </div>
  <!-- container -->
</template>

<script>
import { setMeta } from "@/utils/Meta";
import { getUserDataLambdaInvoke } from "@/utils/LambdaHelper";
import { numberToCurrency, numberToPercentage } from "@/utils/Filter";
import HeadingOne from "@/components/heading/HeadingOne";
import NoticeBox from "@/components/box/NoticeBox";
import NoticeBody from "@/components/box/NoticeBody";
import TableBox from "@/components/tables/TableBox";
import TableBody from "@/components/tables/TableBody";
import TableRow from "@/components/tables/TableRow";
import TableHeader from "@/components/tables/TableHeader";
import TableData from "@/components/tables/TableData";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
export default {
  name: "En010",
  components: {
    BtnMain,
    BtngroupSingle,
    TableData,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    NoticeBody,
    NoticeBox,
    HeadingOne,
  },
  setup() {
    setMeta({
      title: "審査結果のご確認",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,入会,審査,審査結果",
    });
    return {
      numberToCurrency,
      numberToPercentage,
    };
  },
  data() {
    return {
      userData: {
        loan_credit_limit: "0", // ご利用限度額
        loan_contractual_interest_rate: "0", // お借り入れ利率（実質年率）
      },
    };
  },
  mounted() {
    try {
      getUserDataLambdaInvoke()
        .then((res) => {
          for (let key in res) {
            if (Object.prototype.hasOwnProperty.call(this.userData, key)) {
              this.userData[key] = res[key];
            }
          }
        })
        .catch((error) => {
          this.goToErrorPage(error);
        });
    } catch (e) {
      this.goToErrorPage(e);
    }
  },
};
</script>

<style scoped></style>
